import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';

const ArtisticIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="29.791"
      viewBox="0 0 34.989 29.791"
      y={props.yVal}
      x={props.xVal}
      fill={props.color}
      role="img"
    >
      <title>{t('Artistic Icon')}</title>

      <g transform="translate(-0.014)">
        <path
          d="M85.415,18.823h0v-.029L85.006.486A.479.479,0,0,0,84.553,0h-.98a.479.479,0,0,0-.442.486l-.42,18.3v.029h0s-2.037,2.387-.917,4.951c.464,1.072,1.842,2.055,1.775,4.335C83.569,28.109,88.542,25.114,85.415,18.823Z"
          transform="translate(-51.444)"
        />
        <path
          d="M24.147,15.349C27.211,13.994,28,4.019,18.795,1.923,13.719.763,4.565.21.631,11.43-1.21,16.72.292,29.111,16.006,30.584c3.437.317,9.08-.8,9.444-5.477a2.884,2.884,0,0,0-2.527-2.984c-1.842-.306-3.065-1.02-3.183-2.339C19.531,17.361,21.55,16.5,24.147,15.349ZM3.692,13.707a1.915,1.915,0,1,1,.561,1.358A1.919,1.919,0,0,1,3.692,13.707ZM6.5,22.6a1.943,1.943,0,1,0-.015,0ZM9.173,9.389a1.919,1.919,0,1,1,1.915-1.915A1.919,1.919,0,0,1,9.173,9.389ZM13.008,26.7a1.908,1.908,0,1,0,0-.015ZM16.323,7.489a4.276,4.276,0,1,0,.007-.015Z"
          transform="translate(0 -0.844)"
        />
      </g>
    </svg>
  );
};

export default ArtisticIcon;

ArtisticIcon.propTypes = {
  color: PropTypes.string.isRequired,
};
